import { motion, useReducedMotion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is Dearestly really free?",
    a: "Yes. Dearestly Free is free forever — no credit card required, no time limit. Dearestly Plus is USD 4.99 per month or USD 39.99 per year, and you can upgrade or cancel any time.",
  },
  {
    q: "How is Dearestly different from just setting a reminder on my phone?",
    a: "A phone reminder tells you a date. Dearestly tells you what to say — and helps you do something about it. It learns your voice over time, holds the details that make every message feel personal, and now lets you send a curated gift at exactly the right moment. The longer you use it, the more irreplaceable it becomes.",
  },
  {
    q: "Does Dearestly send messages automatically?",
    a: "No — and that's intentional. Dearestly helps you write a message that sounds like you, then you review it and send it yourself. The care is yours. Dearestly just makes sure you never miss the moment.",
  },
  {
    q: "Is my data private?",
    a: "Completely. Your contacts, notes, and relationship details are yours alone. Dearestly has no social features, no public profiles, and your data is never shared or sold to any third party. You can delete your account and all your data at any time.",
  },
  {
    q: "What happens if I cancel Dearestly Plus?",
    a: "Your data stays safe — nothing is deleted. Contacts above the free tier limit are locked but fully preserved. The moment you resubscribe, everything restores instantly exactly as you left it.",
  },
];

const FAQSection = () => {
  const prefersReducedMotion = useReducedMotion();

  const fadeUp = prefersReducedMotion
    ? {}
    : {
        initial: { opacity: 0, y: 24 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true },
        transition: { duration: 0.5 },
      };

  return (
    <section className="bg-background px-6 py-20 md:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <motion.span
          className="mb-4 inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent"
          {...fadeUp}
        >
          Questions
        </motion.span>
        <motion.h2
          className="mb-12 font-serif text-3xl font-semibold text-foreground md:text-4xl"
          {...fadeUp}
        >
          Everything you need to know
        </motion.h2>
      </div>

      <motion.div className="mx-auto max-w-2xl" {...fadeUp}>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="rounded-2xl border-0 bg-card px-6 shadow-sm"
            >
              <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline [&>svg]:text-accent">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </section>
  );
};

export default FAQSection;
